import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPlatform = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	fill: "currentColor",
	viewBox: "0 0 16 16",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		d: "M3.93 4.686A4.46 4.46 0 0 1 8.218 1.5h.033c2.404 0 4.388 1.917 4.48 4.321a2.42 2.42 0 0 1 1.769 2.37v.11a2.452 2.452 0 0 1-2.444 2.449H10.1v-1h1.957c.79 0 1.443-.652 1.443-1.449V8.18a1.42 1.42 0 0 0-1.306-1.442l-.459-.037v-.706A3.497 3.497 0 0 0 8.25 2.5h-.033A3.458 3.458 0 0 0 4.82 5.238l-.077.367-.374.028A2.03 2.03 0 0 0 2.5 7.652v.08c0 1.12.909 2.018 2.01 2.018h2.273v1H4.51A3.016 3.016 0 0 1 1.5 7.733v-.081a3.03 3.03 0 0 1 2.43-2.966Zm3.945 6.642V8h1v3.328a1.626 1.626 0 1 1-1 0Zm-.125 1.547a.625.625 0 1 1 1.25 0 .625.625 0 0 1-1.25 0Z",
		clipRule: "evenodd"
	})
});
export default SvgPlatform;
